<div class="pb-8 flex justify-center">
  <ul id="accordion " class="accordion max-w-4xl mr-3 ml-3">
    <li
      class="border"
      *ngFor="let menu of faq; let i = index"
      [class.active]="menu.active"
    >
      <div class="menu" (click)="toggle(i)">
        <i *ngIf="!menu.active" class="chevron"></i>
        <span *ngIf="menu.active">&times;</span>
        {{ menu.question }}
      </div>
      <ul
        class="submenu"
        #submenu
        [style.height.px]="menu.active ? submenu.scrollHeight : 0"
      >
        <li>
          <ng-container *ngIf="loading">
            <p [innerHTML]="menu.answer" class="text-justify"></p>
          </ng-container>
        </li>
      </ul>
    </li>
  </ul>
</div>
